<div class="link-component">
    <app-layout-horizontal-control>
        <app-control-label top [control]="control" [caption]="caption()"></app-control-label>
        <dx-check-box #dx (onValueChanged)="onValueChanged($event)" (onBlur)="onBlur($event)" [isValid]="true" [value]="computedValue()" [name]="caption()"
            [enableThreeStateBehavior]="false" [readOnly]="readonly()"></dx-check-box>
        <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [helpText]="helpText()" [isValid]="true"></app-control-supporting-text>
    </app-layout-horizontal-control>
</div>
